/* eslint-disable camelcase */
import React, {
    useState, useRef, useEffect, useCallback
} from 'react';
import { useTranslation } from 'react-i18next';
import { makeStyles } from '@material-ui/core/styles';
import MoreVertIcon from '@material-ui/icons/MoreVert';

import RatingComp from '../../../../components/okr/okr_depend_components/ratingComp.component';
import * as OkrPopIpActions from '../../../actions/okr_popup.action';
import KrService from '../../../services/kr.service';
import OKRThreeDotMenuPopup from './okr_menu_popup';
import { RelationshipMapTypes, WbEventHandlerMixins, isReadOnlyUserLicenseType } from '../../../../utils/common';
import { okrDetailConstants } from '../../../../constants/okr/okrDetails.constants';
import { KeyDownEvent } from '../../../../utils/eventKey';
import OkrThreeDotMenu from './okrThreeDotMenu';
import {
    PAGES_TO_SKIP_REFRESH_AND_SCROLL_ON_OKR_POPUP_CLOSE,
    OKR_POPUP_CLOSE_HISTORY_STATE_SOURCE
} from '../../../constants/okrPopUp.constants';

const krService = new KrService();

const useCustomStyles = makeStyles((theme) => ({
    arrow: {
        color: theme.palette.common.black
    },
    tooltip: {
        textAlign: 'center',
        fontSize: 14,
        backgroundColor: theme.palette.common.black
    }
}));

const OKRHeaderKebab = ({
    goals, isFavorites, scrollY, dispatch, goalOldUrl
}: any) => {
    const {
        achieve_by,
        rating,
        days_left,
        id,
        achieved_goal,
        closed_by,
        goal: label,
    } = goals;

    const isClosed = closed_by !== '0';
    const isAchieved = achieved_goal !== '0';
    const isIndividualGoal = Number(goals?.type) === okrDetailConstants.GOAL_TYPE_INDIVIDUAL;
    const [menuOpen, setMenuOpen] = useState(false);
    const [ThreeDotMenuList, setThreeDotMenuList] = useState(null);
    const [hasFavorites, setHasFavorites] = useState(isFavorites);
    const { t } = useTranslation();

    const isLabel = hasFavorites == '0'
        ? t('Pin page to the Objectives navigation')
        : t('Unpin page from Objectives navigation')
    const isTitle = hasFavorites == '0' ? t('Pin to favorites') : t('Unpin from favorites');
    const getMenuList = useCallback(() => {
        $.get(`${wbConfig.baseUrl}/goal/getGoalMenusJson?goalId=${goals.id}`, resp => {
            setThreeDotMenuList(resp.goalMenuItems);
            document.getElementById('okr-kebab-id')?.focus()
        })
            .catch(err => {
                console.log(err);
            })
    }, [goals.id])
    const  isReadOnlyEnabled = isReadOnlyUserLicenseType();

    const SEMButtonId = 'sem-button-id';
    const SEMButtonInit = useCallback(() => {
        if (isIndividualGoal || !window.initSEMComponent) {
            return;
        }
        window.initSEMComponent(
            SEMButtonId,
            {
                baseUrl: `${window.location.origin}/wb/okrs`,
                objectType: RelationshipMapTypes.OBJECTIVE,
                objectId: goals.id,
                tracking: {
                    location: 'OKR_POPUP',
                    object: 'OBJECTIVE',
                }
            }
        );
    }, [goals.id, isIndividualGoal]);

    useEffect(() => {
        window.scrollTo(0, 0);
        getMenuList();
        SEMButtonInit();
    }, [getMenuList]);

    const onCloseModal = () => {
        const globalWin = (window as any);

        const shouldSkipScroll = PAGES_TO_SKIP_REFRESH_AND_SCROLL_ON_OKR_POPUP_CLOSE.some(
            pathname => {
                const lowerPathname = pathname.toLowerCase();
                return window.location.pathname.toLowerCase().includes(lowerPathname) ||
                       window.location.href.toLowerCase().includes(lowerPathname);
            }
        );

        if (typeof goalOldUrl != undefined && goalOldUrl != '') {
            window.location.href = goalOldUrl;
        }
        dispatch(OkrPopIpActions.UpdateModal(false));
        // restore URL shown before GoalDetailsPage was open
        const hasGoalId = window.location.href.includes('wb/goal/index?goalId=');
        if (typeof globalWin.goalDetailsPagePreviousUrl !== 'function') {
            const redirectUrl = hasGoalId
                ? '/wb/goal/index'
                : (globalWin.goalDetailsCallbackUrl || globalWin.goalDetailsPagePreviousUrl);
            window.history.pushState(
                { isCustomRouterStateChange: true, source: OKR_POPUP_CLOSE_HISTORY_STATE_SOURCE },
                '',
                redirectUrl
            );
            window.dispatchEvent(new Event('popstate'));
            globalWin.goalDetailsCallbackUrl = '';
        }
        else {
            globalWin.goalDetailsPagePreviousUrl();
        }

        // For pages in skip list, restore scroll position immediately without animation
        // For other pages, restore to the scroll position before popup opened with animation
        if (shouldSkipScroll) {
            // Restore to original scroll position immediately (no animation)
            // Use setTimeout to ensure it happens after URL changes and popstate event
            setTimeout(() => {
                window.scrollTo(0, scrollY);
            }, 10);
        } else {
            $('html, body').animate({ scrollTop: scrollY }, 250);
        }
    }

    window.closeGoalDetailsPopup = onCloseModal;

    const changePinStatus = (e) => {
        const params = { obj_id: id, obj_type: 'goal', obj_name: label };
        if (label !== t('Pin to favorites') && label !== t('Unpin from favorites')) {
            if (hasFavorites) {
                krService.deleteUserFavorites(params).then((resp) => {
                    setHasFavorites(0);
                    WbEventHandlerMixins.pinGoal(params.obj_type, resp.data, 0, params.obj_id);
                }).catch(err => {
                    console.log(err);
                })
            } else {
                krService.addUserFavorites(params).then((resp) => {
                    setHasFavorites(1);
                    WbEventHandlerMixins.pinGoal(params.obj_type, resp.data.data, 1, params.obj_id);

                }).catch(err => {
                    console.log(err);
                })
            }
        }
    }

    const HamBurgerMenu = () => {
        const ref = useRef();
        const componentProp = {
            ref,
            component: MoreVertIcon,
            color: '#A2B3B8'
        }
        const [anchorEl, setAnchorEl] = useState(null);
        const handleKebab = (e) => {
            setAnchorEl(e.currentTarget);
        }
        const handleClose = () => {
            setAnchorEl(null);
            document.getElementById('okr-kebab-id')?.focus()
        };
        return (
            <>
                { !isReadOnlyEnabled && <div role="application">
                    <OkrThreeDotMenu
                        handleKebab={handleKebab}
                        id="okr-kebab-id"
                        tooltip
                        placement="bottom-end"
                        menuStatus={anchorEl ? true : false}
                        title={<div>{t('Make changes to your objectives')} -<br /> {t('edit, delete, or close.')}</div>}
                    />
                </div>}
                {ThreeDotMenuList && <OKRThreeDotMenuPopup
                    goals={goals}
                    menuList={ThreeDotMenuList}
                    setMenuOpen={setMenuOpen}
                    updateMenuList={getMenuList}
                    dispatch={dispatch}
                    anchorEl={anchorEl}
                    handleClose={handleClose}
                />}
            </>
        )
    }

    const OkrAchieveFlag = ({ achieved }) => (achieved
        ? <span style={{ color: '#78C047' }} className="okr_closed_achieved">{t('Achieved')}</span>
        : <span className="okr_closed_achieved">{t('Not Achieved')}</span>);

    const OkrDateInfo = () => (
        <div className="okr_date_limit">
            <div>
                {isClosed ? (
                    <OkrAchieveFlag achieved={isAchieved} />
                ) : achieve_by}
            </div>
            <div className="okr_date_left">
                <b>{days_left}</b> {days_left < 2 ? t('day') : t('days')} {t('left')}
            </div>
        </div>
    )

    return (
        <div className="header_kebab_section">
            <div className="okr_popup_options">
                {!isIndividualGoal && <div id={SEMButtonId} style={{ padding: '10px 10px' }} />}

                <span
                    className="goal-pin-status"
                    data-pinstatus={hasFavorites}
                    style={{ backgroundSize: 'contain' }}
                    onClick={(e) => { changePinStatus(e) }}
                    onKeyPress={e => KeyDownEvent(e, () => changePinStatus(e))}
                    tabIndex={0}
                    role="button"
                    aria-label={isLabel}
                    title={isTitle}
                    data-type="goal"
                    data-id={id}
                    data-name={label}
                />
                <HamBurgerMenu />
                <span
                    className="close-goal-popup"
                    data-testid="close-goal-popup"
                    onClick={onCloseModal}
                    onKeyDown={e => {
                        KeyDownEvent(e, () => onCloseModal())
                    }}
                    aria-label="close dialog"
                    role="button"
                    tabIndex={0}
                >
                    {/* eslint-disable  max-len */}
                    <svg
                        className="close-goal-popup-button"
                        viewBox="0 0 24 24"
                        aria-hidden="true"
                    >
                        <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
                    </svg>
                </span>
            </div>
            {isClosed ? (
                <div className="okr_closed_rating">
                    <RatingComp key={`goal_rating_${id}`} value={rating} goalId={id} />
                </div>
            ) : <> </>}
            <OkrDateInfo />
        </div>
    )
}

export default OKRHeaderKebab;
